export default "__VITE_PUBLIC_ASSET__96e43ca8__"